import script from "./UploadBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadBox.vue?vue&type=script&lang=ts&setup=true"

import "./UploadBox.vue?vue&type=style&index=0&id=c316930a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c316930a"]])

export default __exports__